/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/no-multi-comp */
import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid, TableCell } from '@material-ui/core';
import { Table } from '../../../components';
import Formulario from './Formulario';

const useStyles = makeStyles(() => ({
  image: {
    height: 50
  },
  fieldContainer: {
    paddingBottom: '0px !important'
  },
  required: {
    color: 'red',
    paddingTop: 5
  }
}));

const UsuarioContainer = ({ onSave, disabled, showError }) => {
  const classes = useStyles();

  const [titles] = useState(['Usuário', 'Arquivo']);
  const [currentUsers, setCurrentUsers] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectData, setSelectData] = useState(null);

  const renderRows = p => {
    return (
      <>
        <TableCell>{p.usuarioNome}</TableCell>
        <TableCell>{p.file?.alt || ''}</TableCell>
      </>
    )
  }

  const onDeleteLocal = id => {
    const users = currentUsers.filter(p => p.id !== id);
    setCurrentUsers(users);
    onClose(users);
  }

  const onClose = users => {
    setOpen(false);
    setSelectData(null);
    onSave(users || currentUsers);
  }

  const onAdd = data => {
    let users = [];

    const existedUsers = currentUsers.filter(p => p.id === data.id);
    if (existedUsers.length > 0) {
      currentUsers.forEach(p => {
        if (p.id === data.id) {
          users.push(data);
        } else {
          users.push(p);
        }
      });
    } else {
      users = [...currentUsers, data];
    }

    setCurrentUsers(users);
    onClose(users);
  }

  const onEdit = id => {
    setSelectData(currentUsers.filter(p => p.id === id)[0]);
    setOpen(true);
  }

  return (
    <>
      <Grid item xs={12} className={classes.root}>
        <Table
          rows={currentUsers}
          titles={titles}
          headerTitle="Usuários"
          deleteMessage="Tem certeza que deseja remover o usuário"
          renderRows={renderRows}
          hasRowActions
          onDelete={onDeleteLocal}
          onEdit={onEdit}
          hasAdd={disabled === undefined || disabled === false}
          showDelete={disabled === undefined || disabled === false}
          showEdit={disabled === undefined || disabled === false}
          onAdd={() => setOpen(true)}
          showEmptyState={false}
          showError={showError}
        />
      </Grid>
      <Formulario
        selectData={selectData}
        open={open}
        onClose={onClose}
        onAdd={onAdd}
      />
    </>
  );
};

export default UsuarioContainer;
